'use client'

import AppendRoot from '@component/appendRoot'
import CloseButton from '@component/closeButton'
import FullPopup from '@component/fullPopup'
import useVideoPlayer from '@hooks/useVideoPlayer'
import { useUnmount } from 'react-use'
import VideoPlayerContent from './content'

export default function VideoPlayer() {

  const { show, url, hideVideoPlayer } = useVideoPlayer()

  useUnmount(() => {
    hideVideoPlayer()
  })
  return (
    <AppendRoot>
      <FullPopup show={show} smCenter mobileFull contentClassName='!bg-transparent sm:px-10' zIndex={100}>
        {
          show && (
            <div className='w-screen h-fill-screen relative flex items-center bg-white px-10 sm:w-[900px] sm:h-auto sm:max-w-full sm:px-98 sm:py-48'>
              <CloseButton className='absolute right-6 top-6' onClick={hideVideoPlayer}></CloseButton>
              <VideoPlayerContent url={url}></VideoPlayerContent>
            </div>
          )
        }
      </FullPopup>
    </AppendRoot>
  )
}
